module.exports = __webpack_public_path__ + "static/media/achievement.7ba2c0ad.svg";